import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../styles/HomePage.css";

function HomePage() {
  return (
    <div className="home-page">
      <Helmet>
        {/* Titre affiché sur Google (Maximum 60-65 caractères) */}
        <title>FootVision Live | Pronostics, Scores en Direct, Statistiques & Analyses foot</title>
        
        {/* Description de la page sur Google (Maximum 155-160 caractères) */}
        <meta name="description" content="Suivez le foot en temps réel sur FootVision Live. Accédez aux scores, compositions, analyses de données approfondies et signaux algorithmiques exclusifs." />
        
        {/* Optimisation pour les partages de liens (WhatsApp, Facebook, etc.) */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="FootVision Live | Voir les matchs avant qu'ils commencent" />
        <meta property="og:description" content="L'avantage statistique qui transforme vos pronostics. Scores en direct, analyses de données et signaux algorithmiques." />
        <meta property="og:url" content="https://www.footvisionlive.com" />
        {/* Utilisation de votre logo situé dans le dossier public pour l'aperçu du lien */}
        <meta property="og:image" content="https://www.footvisionlive.com/logo1.png" />
      </Helmet>

      <section className="hero-section">
        <h1>
          ⚽️ FootVision <span style={{color: "var(--rouge)"}}>Live </span>
        </h1>

        <h2>Voir les matchs avant qu'ils commencent </h2>

        <p>L'avantage statistique qui transforme vos pronostics. </p>
        <p>Accédez en temps réel aux scores, compositions, analyses de données approfondies et signaux algorithmiques pour prendre une longueur d'avance sur chaque match. </p>

        <div className="hero-buttons">
          <Link style={{background: "var(--citron)", color: "var(--black)", fontSize: "18px", fontWeight: "bold", animation: "glissement-droit 1.6s ease forwards"}} to="/matches">
            Voir les matchs
          </Link>

          <Link style={{transform: "scale(1.08)", animation: "glissement-gauche 1.6s ease forwards"}} to="/vip/compositions">
            Voir les compos
         </Link>
        </div>

        <div className="stats">
          <div className="stat">
            <span>+1 200</span>
            <p>Matchs analysés</p>
          </div>
          <div className="stat">
            <span>78%</span>
            <p>Taux de réussite</p>
          </div>
          <div className="stat">
            <span>Quotidien</span>
            <p>Mises à jour</p>
          </div>
        </div>
      </section>

      <section id="savoirPlus" className="features">
        <h2>Pourquoi nous choisir ?</h2>

        <div className="feature-grid">
          <div className="card">
            <h3><i className="fas fa-bullseye"></i>⚽ Pronostics Data & Statistiques Avancées</h3>
            <p>Prédictions précises incluant le score à la mi-temps.</p>
            <p>Oubliez la chance. Nos pronostics sont générés grâce à l’analyse croisée de données historiques complexes, de l'état de forme algorithmique et de modèles statistiques avancés.</p>
            <p>Une aide à la décision indispensable pour optimiser vos performances.</p>
          </div>

          <div className="card">
            <h3><i className="fas fa-chart-column"></i>📊 Analyse avancée</h3>
            <p>Statistiques clés, forme actuelle, dynamique des équipes.</p>
            <p>Soyez informé dès la publication officielle des compositions de départ.</p>
            <p>Analysez les systèmes tactiques mis en place par les entraîneurs avant le coup d'envoi pour détecter immédiatement les forces et les faiblesses de chaque équipe.</p>
          </div>

          <div className="card">
            <h3><i className="fas fa-bullseye"></i>🔴 Live Scores & Statistiques en Direct</h3>
            <p>Vivez chaque rencontre à la seconde près.</p>
            <p>Au-delà de l'évolution du score, accédez instantanément au flux de statistiques en direct (possession, tirs cadrés, attaques dangereuses) pour ressentir la dynamique du match sur tous vos écrans.</p>
          </div>
          
          <div className="card">
            <h3><i className="fas fa-check"></i>📋 compositions des matchs</h3>
            <p>Les matchs aux probabilités les plus fiables, sélectionnés avec rigueur.</p>
          </div>
          
          <div className="card">
            <h3><i className="fas fa-lightbulb"></i> ⚡ Signaux Avancés & Alertes Live</h3>
            <p>Une opportunité se présente en plein match ?</p>
            <p>Notre algorithme scanne les métriques en temps réel et génère des signaux avancés (ex: domination soudaine, carton rouge impactant, baisse d'intensité) pour vous alerter sur les meilleurs coups à jouer en direct.</p>
          </div>
{/*
  
          <div className="card">
            <h3><i className="fas fa-brain"></i>👑 FootVision VIP</h3>
            <p>Passez à la vitesse supérieure avec FootVision VIP. Le football de haut niveau ne laisse rien au hasard, votre stratégie non plus.</p>
            <p>En rejoignant le Club VIP, vous débloquez un accès total à notre écosystème de données : Analyses pré-match exclusives rédigées par nos modèles prédictifs.</p>
            <p>Signaux algorithmiques en temps réel pour capturer les tendances d'un live avant tout le monde. Fiabilité chiffrée (%) sur tous les types de paris (Score Exact, BTTS, Plus/Moins 2.5, etc...).</p>
          </div>

            */}
        </div>
      </section>
{/*
      <section className="cta">
        <h2>⚡ Prêt à transformer votre vision du jeu ? Pour le prix d’un café par mois, offrez-vous l'outil ultime d'analyse footballistique.</h2>
        <Link to="/vip">Devenir VIP</Link>
      </section>

          */}
      <section className="cta">
        <h2>Prêt à voir le football autrement ?</h2>
        <Link to="/matches">Découvrir FootVision</Link>
      </section>
    </div>
  );
}

export default HomePage;
